// extracted by mini-css-extract-plugin
export default {"popup":"DisplayStageDeleteCampaign_popup__7hp5r","canvas":"DisplayStageDeleteCampaign_canvas__H1Y73","buttonContainer":"DisplayStageDeleteCampaign_buttonContainer__VFFok"};